import { render, staticRenderFns } from "./handleServer.vue?vue&type=template&id=99f7fa5a&scoped=true&"
import script from "./handleServer.vue?vue&type=script&lang=js&"
export * from "./handleServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f7fa5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99f7fa5a')) {
      api.createRecord('99f7fa5a', component.options)
    } else {
      api.reload('99f7fa5a', component.options)
    }
    module.hot.accept("./handleServer.vue?vue&type=template&id=99f7fa5a&scoped=true&", function () {
      api.rerender('99f7fa5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/automaticServer/handleServer.vue"
export default component.exports